export default {
  dateToYMD: (date) => {
    if (!date) {
      return false
    }
    let d = date.split('.')
    if (d.length !== 3) {
      return false
    }
    return d[2] + '-' + d[1] + '-' + d[0]
  }
}
